import { create } from 'zustand';
import type { ActiveQuestionStep } from '../lib/api';

type AppState = {
  isOnline: boolean;
  activeQuestions: ActiveQuestionStep[];
  currentQuestionIndex: number;
  setOnline: (v: boolean) => void;
  setActiveQuestions: (q: ActiveQuestionStep[]) => void;
  setCurrentQuestionIndex: (index: number) => void;
  resetQuestionSequence: () => void;
};

export const useAppStore = create<AppState>((set) => ({
  isOnline: true,
  activeQuestions: [],
  currentQuestionIndex: 0,
  setOnline: (v) => set({ isOnline: v }),
  setActiveQuestions: (q) => set({ activeQuestions: q }),
  setCurrentQuestionIndex: (index) => set({ currentQuestionIndex: Math.max(0, Math.floor(index)) }),
  resetQuestionSequence: () => set({ activeQuestions: [], currentQuestionIndex: 0 }),
}));
